import { useContext } from "react"
import { XAxisContext } from "./XAxisContext"
import type { XAxisContextValue } from "./XAxisContextValue"

export function useXAxisContext(): XAxisContextValue {
  return useContext(XAxisContext)
}
